import React from 'react';
import PropTypes from 'prop-types';
import analyticsWrapper from 'helpers/analytics/analyticsWrapper';
import Link from 'components/Link';
import s from './browseByFeed.scss';

function BrowseByFeed(props) {
  const { data, userData } = props;
  const { isLoggedIn = undefined } = userData;
  const prcValue = userData && userData.prcValue ? userData.prcValue : 0;

  if (!data?.items || !data?.name) {
    return null;
  }

  return (
    data &&
    data.name &&
    data.items && (
      <div className={s.browseByFeedWidget}>
        <h3 className={s.heading}>{data.name}</h3>
        <div className={s.feedBtnsBlock}>
          {data.items.map(
            (val, i) =>
              val.link &&
              val.label && (
                <Link
                  key={`${val}_${i}`}
                  className={s.feedBtn}
                  href={`${val.link}`}
                  onClick={() => {
                    analyticsWrapper(
                      'ga',
                      'send',
                      'event',
                      'TOI Plus',
                      `TOIPlus_HomePage_browseByFeed_${val.label}_click`,
                      `Ps-${!isLoggedIn && prcValue === 0 ? -1 : prcValue}`,
                    );
                  }}
                >
                  {val.label}
                </Link>
              ),
          )}
        </div>
      </div>
    )
  );
}
BrowseByFeed.propTypes = {
  data: PropTypes.objectOf(PropTypes.object),
  userData: PropTypes.shape({
    isLoggedIn: PropTypes.bool,
    prcValue: PropTypes.number,
  }),
};

BrowseByFeed.defaultProps = {
  data: {},
  userData: undefined,
};
export default BrowseByFeed;
